import posthog from 'posthog-js';

import { envFeatureFlags } from '~utils/policies';
import { SNAKE_DELIVERY_TYPES } from '~constants/delivery';

export const getMinDeliveryOption = (options) =>
  options.reduce((minOption, option) => {
    if (option.value) {
      if (option.value.estimatedTotalDeliveryPrice < minOption.min || !minOption.type) {
        minOption = {
          min: option.value.estimatedTotalDeliveryPrice,
          type: option.value.deliveryType,
          expireDate: option.value.expiresAt,
          estimationId: option.value.id
        };
      }
    }
    return minOption;
  }, {});

export const getRappiCargoEnabled = () =>
  posthog.isFeatureEnabled(`rappiCargo${envFeatureFlags[process.env.REACT_APP_ENV]}`);

export const filterDisabledMethods = (deliveryMethods = []) => {
  return deliveryMethods.filter((method) => method.deliveryType !== SNAKE_DELIVERY_TYPES.UberDelivery);
};
